// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { UFState } from 'uf/state';
import { getFlagHeaders } from 'uf/user/selectors/flags';

const DEFAULT_API_SERVER_ORIGIN = 'http://localhost:8080';
const API_SERVER_ORIGIN =
  process.env.UF_API_SERVER_ADDR || DEFAULT_API_SERVER_ORIGIN;

export const REJECT_AUTH = 'uf/authentication/REJECTED';

export const baseQuery = fetchBaseQuery({
  baseUrl: `${API_SERVER_ORIGIN}/api`,
  credentials: 'include',
  prepareHeaders: (headers, api) => {
    const state = api.getState();
    // Get toggled feature flags
    const flagHeaders = getFlagHeaders(state as UFState);
    headers.set('UF-Frontend-Version', __BUILD_INFO__.git_commit);
    headers.set('UF-Feature-Flags', flagHeaders['UF-Feature-Flags']);
  },
});

const customBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (
    result?.error?.status === 401 &&
    !result?.meta?.request?.url?.includes('current_user')
  ) {
    api.dispatch({
      type: REJECT_AUTH,
    });
  }
  return result;
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
  reducerPath: 'api-rtk',
});
